import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { fetchTimeout } from "../components/Common";
import { Palette, API_BASE } from "../AppConfig";
import RecallQuotesLayout from "./RecallQuotesLayout";

import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import CircularProgress from "@material-ui/core/CircularProgress";
import LinearProgress from "@material-ui/core/LinearProgress";
import Backdrop from "@material-ui/core/Backdrop";
import Typography from "@material-ui/core/Typography";
import Message from "../components/Message";
import AppsIcon from "@material-ui/icons/Apps";
import ListIcon from "@material-ui/icons/List";

import TextField from "@material-ui/core/TextField";
import SearchIcon from "@material-ui/icons/Search";

import { updateAPP } from "../redux_store/appState";
import BSL_Dialog from "../components/BSL_Dialog";
import SegmentedButtonGroup from "../components/SegmentedButtonGroup";

const useStyles = makeStyles((theme) => ({
    page: {
        marginLeft: "120px",
        marginRight: "40px",
        marginTop: "20px",
        textAlign: "left",
        display: "flex",
        flexDirection: "column",
        minHeight: "600px",
    },
    header: {
        fontWeight: "400",
        letterSpacing: "1px",
        paddingRight: "20px",
        verticalAlign: "text-top",
        color: theme.brand.LYSAGHT ? theme.palette.primary.light : Palette.Control.DarkGrey,
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.brand.LYSAGHT ? "24pt" : "18pt",
        textTransform: theme.brand.LYSAGHT ? "uppercase" : "capitalize",
        fontWeight: theme.brand.LYSAGHT ? "800" : "inherit",
        flex: 1,
    },
    view_panel: {
        font: "12pt " + theme.typography.fontFamily,
        display: "flex",
        alignItems: "center",
    },
    search_container: {
        borderRadius: "50px",
        border: "1px solid #6B8799",
    },
    search_icon: {
        width: "0.75em",
        height: "0.75em",
        color: "grey",
        marginLeft: "7px",
        verticalAlign: "-webkit-baseline-middle",
    },
    input: {
        display: "none",
    },
    backdrop: {
        zIndex: 10,
        color: "#fff",
        flexDirection: "column",
    },
}));

const StyledMenuItem = withStyles((theme) => ({
    root: {
        font: "12pt " + theme.typography.fontFamily,
    },
}))(MenuItem);

const StyledSelect = withStyles((theme) => ({
    root: {
        font: "12pt " + theme.typography.fontFamily,
        marginLeft: "6px",
        color: "#002D62",
        // textDecoration: "underline"
    },
}))(Select);

export default function JobOrdersPage(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [collection_tab_index, setcollection_tab_index] = React.useState(0);
    const [loading, setLoading] = React.useState(true);
    const [backDrop, setBackDrop] = React.useState(false);
    const [viewStyle, setViewStyle] = React.useState("Grid");
    const [searchFilter, setSearchFilter] = React.useState("");
    const [currentBusinessId, setCurrentBusinessId] = React.useState("ALLJOBS");
    const [containerMode, setContainerMode] = React.useState("");
    const [showMessage, setShowMessage] = React.useState(false);
    const [dialogData, setDialogData] = React.useState(false);
    const [orderJobs, setOrderJobs] = React.useState([]);
    const user = useSelector((state) => state.app.user);
    const user_region_0 = user?.BusinessDetails?.Offer?.Regions?.[0];

    const offering_brand = useSelector((state) => state.app?.offerings?.[user?.BusinessDetails?.Offer?.Brand]);
    const offering_region_0 = offering_brand?.Regions?.[user_region_0]?.region;
    // const config_region = useSelector(state => state.config?.region);
    const main_page = useSelector((state) => state.app.MAIN_PAGE);

    let POAFilter = "XXX";
    let region_name = "None";
    //
    if (offering_region_0) {
        POAFilter = offering_region_0.id;
        region_name = offering_region_0.name;
    }
    if (user?.Role > 91) {
        POAFilter = "";
        region_name = "All Regions";
    }

    useEffect(() => {
        if (user?.Role && region_name !== "None") {
            if (window.debug && window.location.href.includes("use_cache")) {
                setLoading(false);
            } else {
                setLoading(true);
                fetchTimeout(API_BASE() + `job/` + currentBusinessId, {
                    method: "POST",
                    body: JSON.stringify({ Status: "Ordered", Container: "", POAFilter: POAFilter, NumItems: 200 }),
                })
                    .then(async (res) => {
                        if (res.status >= 200 && res.status <= 300) {
                            let json_order_data = await res.json();
                            setOrderJobs(json_order_data[0].Jobs);

                            let orders_pending = [];
                            for (var item of json_order_data[0].Jobs) {
                                const orderStatus = (item?.OrderStatus || "").toUpperCase();
                                if (orderStatus === "PENDING") orders_pending.push(item);
                            }

                            dispatch(updateAPP("number_orders_to_process", orders_pending.length));
                        } else {
                        }
                        setLoading(false);
                    })
                    .catch((e) => {
                        setLoading(false);
                    });
            }
        }
    }, [user.id, props.visible, main_page]);

    if (!props.visible) return null;

    let orders_pending = [];
    let orders_reviewed = [];
    let orders_accepted = [];

    for (var item of orderJobs) {
        const orderStatus = (item?.OrderStatus || "").toUpperCase();
        if (orderStatus === "PENDING") orders_pending.push(item);
        if (orderStatus === "REVIEWED") orders_reviewed.push(item);
        if (orderStatus === "ACCEPTED") orders_accepted.push(item);
    }

    return (
        <div className={classes.page}>
            <div style={{ display: "flex", flexDirection: "row" }}>
                <span className={classes.header}>Pending Processing ({region_name})</span>
                <div style={{ display: "flex", marginBottom: "4px" }}>
                    <div className={classes.view_panel}>
                        <div className={classes.search_container}>
                            <SearchIcon className={classes.search_icon} />
                            <form
                                noValidate
                                style={{
                                    display: "inline",
                                }}
                            >
                                <TextField
                                    id="Search"
                                    placeholder="Search"
                                    type="text"
                                    InputProps={{ disableUnderline: true }}
                                    onChange={(e) => setSearchFilter(e.target.value)}
                                />
                            </form>
                        </div>
                        {/* <BSL_Select value="Last Edited" items={[, "Suburb", "Job Number"]} label="" border={false}/> */}

                        <SegmentedButtonGroup
                            value={viewStyle}
                            // style={{
                            //     marginLeft: '-18px',
                            // }}
                            items={[
                                { Key: "Grid", Display: <AppsIcon /> },
                                { Key: "Table", Display: <ListIcon /> },
                            ]}
                            onChange={(e, val) => {
                                setViewStyle(val);
                            }}
                        />
                    </div>
                </div>
            </div>
            {loading && (
                <LinearProgress style={{ marginTop: "0px", height: "4px", marginBottom: "-4px" }} color={"primary"} />
            )}
            {backDrop && (
                <Backdrop className={classes.backdrop} open={backDrop}>
                    <>
                        <CircularProgress color="inherit" />
                        <br />
                        <Typography variant="overline" gutterBottom style={{ marginTop: "20px" }}>
                            {backDrop}
                        </Typography>
                    </>
                </Backdrop>
            )}

            <RecallQuotesLayout
                searchFilter={searchFilter}
                businessCode={currentBusinessId}
                setLoading={setLoading}
                jobs={orders_pending}
                displayMode={viewStyle}
                containerMode={containerMode}
                noJobMessage={"- No Orders Pending -"}
            />

            {orders_reviewed.length > 0 && (
                <>
                    <div style={{ marginTop: "20px" }}>
                        <span className={classes.header}>
                            Reviewed / Awaiting Response from Customer ({region_name})
                        </span>
                    </div>

                    <RecallQuotesLayout
                        searchFilter={searchFilter}
                        businessCode={currentBusinessId}
                        setLoading={setLoading}
                        jobs={orders_reviewed}
                        displayMode={viewStyle}
                        containerMode={containerMode}
                        noJobMessage={"- No Orders Awaiting Response -"}
                    />
                </>
            )}

            <div style={{ marginTop: "20px" }}>
                <span className={classes.header}>Accepted / Recently Processed ({region_name})</span>
            </div>

            <RecallQuotesLayout
                searchFilter={searchFilter}
                businessCode={currentBusinessId}
                setLoading={setLoading}
                jobs={orders_accepted}
                displayMode={viewStyle}
                containerMode={containerMode}
                noJobMessage={"- No Orders Accepted -"}
            />

            <Message
                open={showMessage}
                message={showMessage?.message}
                type={showMessage?.type}
                onClose={() => setShowMessage(null)}
            />

            <BSL_Dialog
                title={dialogData.title}
                open={dialogData}
                onClose={() => setDialogData(false)}
                button1Text={dialogData?.primaryActionText ? dialogData?.primaryActionText : "OK"}
                button1Click={() => {
                    setDialogData(false);
                    if (dialogData?.primaryAction) dispatch(dialogData.primaryAction);
                }}
                button2Text={dialogData?.secondaryActionText}
                button2Click={() => {
                    setDialogData(false);
                    if (dialogData?.secondaryAction) dispatch(dialogData.secondaryAction);
                }}
            >
                {dialogData.message}
            </BSL_Dialog>
        </div>
    );
}
